<div class="row justify-content-center mt-5 mb-5" *ngIf="!dataLoaded">
    <mat-spinner [diameter]="'70'" [color]="'warn'"></mat-spinner>
</div>
<div class="container" class="m-5" *ngIf="favouritePropertyList.length == 0">
    <div class="row">
        <div class="col-sm-12">
            <h2 class="info-text">Please <mat-icon>favorite</mat-icon> favourite some property :)</h2>
        </div>
    </div>
</div>
<div class="container" class="m-3" *ngIf="favouritePropertyList.length > 0">
    <div class="card mb-3" *ngFor="let property of favouritePropertyList">
        <div class="card-horizontal" (click)="viewProperty(property.id)" style="cursor: pointer;">
            <div class="img-square-wrapper">
                <img *ngIf="property.featuredImage" [src]="property.featuredImage" class="Card image cap w-100 h-100">
                <img *ngIf="!property.featuredImage" src="assets/placeholder-image.png" class="Card image cap w-100 h-100">
            </div>
            <div class="card-body">
                <h5 class="card-title">{{ property.title }}</h5>
                <small><img src="assets/signs.png" style="height: 16px; width: 15px;"> {{ property.address }}</small>
                <hr class="divider">
                <div class="row">
                    <div class="col-12">
                        <p *ngIf="property.totalArea"><strong>Total Area : </strong> {{ property.totalArea }} (Bigha)</p>
                        <p><strong>Distance from Road : </strong> {{ property.distFromRoad }}</p>
                        <p class="price"><strong>Price : </strong> NRS {{ property.price }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-between align-items-center">
            <p><strong>Property Type : </strong>{{ property.PropertyType.type }}</p>
            <button mat-button class="favorited-button" (click)="removeFromFavourite(property.favourite_id)" aria-label="Remove from favorite">
                <mat-icon>favorite</mat-icon> Remove from favourite
            </button>
        </div>
    </div>
</div>